import { Stack, Typography } from '@mui/material';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

export function CardapioVazioKiosk(): JSX.Element {
  return (
    <Stack sx={{ flexGrow: 1, alignItems: 'center', justifyContent: 'center', gap: 2, p: 4, textAlign: 'center' }}>
      <RestaurantMenuIcon sx={{ fontSize: 96, opacity: 0.4 }} />

      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        Cardápio chegando
      </Typography>

      <Typography variant="h6" color="text.secondary">
        Estamos preparando o cardápio desta loja.
      </Typography>
    </Stack>
  );
}
